export const SPECIAL_TYPE_TOGGLE_MORE = 'SPECIAL_TYPE_TOGGLE_MORE';

export const MORE = 'more';
export const LESS = 'less';

export const NUMBER_OF_ITEMS_TO_DISPLAY_ON_WIDGET = 4;

export const CommunicationStatusTypes = {
  PUBLISHED: 'PUBLISHED',
  DRAFT: 'DRAFT',
};

export const CommunicationStatuses = [
  { value: CommunicationStatusTypes.PUBLISHED, label: 'Published' },
  { value: CommunicationStatusTypes.DRAFT, label: 'Draft' },
];

export const CommunicationTypes = {
  ANNOUNCEMENT: 'A',
};

export const CommunicationTypesOptions = [
  { value: 'A', label: 'Service Announcement' },
];

export const NotificationSectionName = {
  configurationDiagnostics: 'Configuration Diagnostics',
  unpostedGLJournals: 'Unposted GL Journals',
  taxEntriesPendingApproval: 'Tax Entries Pending Approval',
  declinedTaxEntries: 'Declined Tax Entries',
  taxEntriesToApprove: 'Tax Entries to Approve',
};
